module.exports = __webpack_public_path__ + "static/media/setting-history.17986bf6.png";